import Vue from 'vue'
import Toast from 'vue-toastification'

import { NOTIFICATIONS_MUTE_PERMISSION } from '@/constants/permissions'
import { authState } from '@/core/auth/authState'

// Toast Notification Component Styles
import '@/core/scss/vue/libs/toastification.scss'
// import "vue-toastification/dist/index.css"

export const isToastMuted = () =>
  authState.permissions.includes(NOTIFICATIONS_MUTE_PERMISSION)

export const filterMutedToasts = toast => !isToastMuted() && toast

/**
 * NOTE: If you are using other transition them make sure to import it in `src/core/scss/vue/libs/notification.scss` from it's source
 */
Vue.use(Toast, {
  newestOnTop: true,
  hideProgressBar: true,
  closeOnClick: false,
  closeButton: false,
  icon: false,
  timeout: 3000,
  transition: 'Vue-Toastification__fade',
  filterBeforeCreate: filterMutedToasts,
})
